module.exports = __webpack_public_path__ + "static/img/green_p.86861217.png";